import { render, staticRenderFns } from "./FormModeItem.vue?vue&type=template&id=873a76fe&"
import script from "./FormModeItem.vue?vue&type=script&lang=js&"
export * from "./FormModeItem.vue?vue&type=script&lang=js&"
import style0 from "./FormModeItem.vue?vue&type=style&index=0&id=873a76fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports